package com.eladfinish.bible.contest.ui.ads

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * No in-app ads on Web. AdSense rejected the canvas-only app ("Google-served ads on screens
 * without publisher content" — a crawler sees no text on a Compose canvas, and most app screens
 * are menus/navigation), so web ads live on the generated static content pages instead (see the
 * :webContent module), not inside the app at /app/.
 */
@Composable
actual fun AdMobBottomBanner(
    modifier: Modifier,
) {
}
